<div class="container-fluid text-center" [ngStyle]="{'background-image':'url('+image+')'}" >
  <h1>{{title}}</h1>
  <small><p>{{ subtitle }}</p></small>
</div>
